// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAevT1myK-ABSAFPfgJge_aPJgid7gnnSk",
  authDomain: "tech-performance-centre.firebaseapp.com",
  projectId: "tech-performance-centre",
  storageBucket: "tech-performance-centre.firebasestorage.app",
  messagingSenderId: "1015482870754",
  appId: "1:1015482870754:web:59a94767c0b59c7e1ea7bb",
  measurementId: "G-5GEK28BXTL",
};

// AndUs Education Firebase configuration (for intake blocks)
const andusConfig = {
  apiKey: "AIzaSyDmMo9Xhag4ha3EODGZ3TRCYqSZ6p2kaVc",
  authDomain: "andus-education.firebaseapp.com",
  projectId: "andus-education",
  storageBucket: "andus-education.appspot.com",
  messagingSenderId: "539197944862",
  appId: "1:539197944862:web:2f25e52ead88f3ab5eea0f",
  measurementId: "G-B8MVPJZ3L0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
// Initialize critical services immediately
const db = getFirestore(app);


// Lazy initialize non-critical services
let andusAppInstance = null;
let andusDbInstance = null;
let authInstance = null;
let storageInstance = null;
let analyticsInstance = null;

// Initialize AndUs app only when needed (for intake blocks)
export const getAndusDb = () => {
  if (!andusDbInstance) {
    andusAppInstance = initializeApp(andusConfig, "andusEducation");
    andusDbInstance = getFirestore(andusAppInstance);
  }
  return andusDbInstance;
};

// Initialize auth only when needed
export const getAuthInstance = () => {
  if (!authInstance) {
    authInstance = getAuth(app);
  }
  return authInstance;
};

// Initialize storage only when needed
export const getStorageInstance = () => {
  if (!storageInstance) {
    storageInstance = getStorage(app);
  }
  return storageInstance;
};

// Lazy load analytics for better performance
if (typeof window !== "undefined") {
  // Initialize analytics asynchronously after page load
  setTimeout(() => {
    analyticsInstance = getAnalytics(app);
    console.log("✅ Analytics initialized");
  }, 2000);
}

// Export the initialized services to use them in your components
export { db, functions };

// Export analytics getter that can be used to check if initialized
export const getAnalyticsInstance = () => analyticsInstance;

// Check if analytics is ready
export const isAnalyticsReady = () => analyticsInstance !== null;

// For backwards compatibility, create proxy exports
export const auth = new Proxy(
  {},
  {
    get: (target, prop) => {
      const instance = getAuthInstance();
      return instance[prop];
    },
  }
);

export const storage = new Proxy(
  {},
  {
    get: (target, prop) => {
      const instance = getStorageInstance();
      return instance[prop];
    },
  }
);

export const andusDb = new Proxy(
  {},
  {
    get: (target, prop) => {
      const instance = getAndusDb();
      return instance[prop];
    },
  }
);
